import { render } from "./MovementList.vue?vue&type=template&id=50baea05&scoped=true&ts=true"
import script from "./MovementList.vue?vue&type=script&lang=ts"
export * from "./MovementList.vue?vue&type=script&lang=ts"

import "./MovementList.vue?vue&type=style&index=0&id=50baea05&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50baea05"]])

export default __exports__